import {createTheme} from "@variocube/cube-ui";

export const themeOptions = {
    colorBackground: "#333",
    colorForeground: "#fff",
    colorPrimary: "#F2892F",
};

export const theme = createTheme(themeOptions);

